<template>
  <mdb-card :style="{ 'background-color': backgroundcolor }" v-if="loadReady">
    <mdb-card-body>
      <mdb-row>
        <img :src="logosrc" alt="..." />
      </mdb-row>
      <mdb-row>
        <img :src="imagesrc" alt="..." />
      </mdb-row>
      <mdb-row>
        <img src="../assets/img/cslogo.png" alt="..." />
      </mdb-row>
      <mdbRow :style="{ 'color': fontcolor}">CityShoppari-edut</mdbRow>
      <hr />
      <mdb-row>
        <p :style="{ 'color': fontcolor }">{{ benefittext }}</p>
      </mdb-row>
      <hr />
      <mdb-row>
        <p :style="{ 'color': fontcolor }">{{ othertext }}</p>
      </mdb-row>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import { mdbRow, mdbCard, mdbCardBody } from "mdbvue";

export default {
  name: "FrontPage",
  components: {
    mdbRow,
    mdbCard,
    mdbCardBody,
  },
  props: {
    imagesrc: String,
    logosrc: String,
    benefittext: String,
    othertext: String,
    loadReady: Boolean,
    backgroundcolor: String,
    fontcolor: String,
  },
  mounted() {
    console.log(this.backgroundcolor);
  },
};
</script>

<style>

</style>
